export default __webpack_public_path__ + "images/87fbea07123f2e500b5daa6b710e05c7-lung_icon.png";